import { useTranslations } from 'next-intl';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { generalEnv } from '@nx-frontend/shared/env';

export const UpgradePlanMessage = () => {
  const t = useTranslations('features');
  return (
    <div className="flex w-full items-start px-4 py-2.5 border border-green-500/15 bg-green-200/15 rounded">
      <div className="mr-2">
        <Icon icon={IconsMap.THREE_STARS} className="w-5 h-5 text-cyan-900" />
      </div>
      <p className="font-inter text-sm text-left">{t('manage-members.invite_members_without_card')}</p>
      <Button
        type={ButtonType.PRIMARY}
        className="px-6 py-2 ml-4"
        size={ButtonSize.CUSTOM}
        onClick={() => {
          window.open(`https://${generalEnv.nimbusDomain}/pricing.php`, '_blank');
        }}
      >
        {t('manage-members.upgrade_plan')}
      </Button>
    </div>
  );
};
